import React, { useState, useEffect } from 'react';

import { ReactComponent as DeleteIcon } from '../../../../../assets/svg/solobuilder/delete.svg';
import { ReactComponent as EditIcon } from '../../../../../assets/svg/solobuilder/edit.svg';
import { ReactComponent as SaveIcon } from '../../../../../assets/svg/solobuilder/save.svg';

interface IProps {
  option: any,
  options: any[],
  updateOptions: (data: any, key: string) => void,
  canEdit?: boolean,
  isCheckedIn?:boolean,
  pluginType?:any;
}

export const ListData = (props: IProps) => {
  const { canEdit = true ,pluginType = ""} = props
  const option = props.option
  const options = props.options

  const [isEdit, setEdit] = useState(false)

  const [label, setLabel] = useState('')
  const [value, setValue] = useState('')
  const [iconUrl, setIconUrl] = useState("")

  useEffect(() => {
    setLabel(option.label)
    setValue(option.value)
    setIconUrl(option?.iconUrl)
  }, [option])

  const checkIfPresent = (id: number, range: any[], key: any, prop: any) => {
    const updatedOptions = range.filter((item) => item.id !== option.id)
    return updatedOptions.find((el) => el[`${key}`].toLowerCase() === prop.toLowerCase())
  }

  const deleteOption = () => {
    const updatedOptions = options.filter((item) => item.id !== option.id)
    props.updateOptions(updatedOptions, 'properties.data.options')
  }

  const editOption = () => {
    if (isEdit) {
      const valuePresent = checkIfPresent(option.id, options, 'value', value)
      if ((label && value) &&   !valuePresent) {
        const updatedOptions = [...options]
        updatedOptions[options.findIndex((item) => item.id === option.id)].label = label
        updatedOptions[options.findIndex((item) => item.id === option.id)].value = value
        if (pluginType === "Tag"){
          updatedOptions[options.findIndex((item) => item.id === option.id)].iconUrl = iconUrl
        }
        props.updateOptions(updatedOptions, 'properties.data.options')
        setEdit(!isEdit)
      }
    } else {
      setEdit(!isEdit)
    }
  }

  return (
    pluginType === "Tag" ?
    <div className="flex items-center justify-between flex-wrap">
      <input
        style={{cursor: (!props.isCheckedIn || !isEdit) ? "not-allowed" : "auto", width:"118px", height:"28px", borderRadius:"2px"}}
        className="bg-white border border-gray-300 text-gray-900 text-base block p-1.5 focus:outline-none"
        disabled={!props.isCheckedIn || !isEdit}
        placeholder="Label"
        value={label}
        onChange={(e) => {
          setLabel(e.target.value)
        }} />

      <input
        style={{cursor: (!props.isCheckedIn || !isEdit) ? "not-allowed" : "auto", width:"118px", height:"28px", borderRadius:"2px"}}
        className="bg-white border border-gray-300 text-gray-900 text-base block p-1.5 focus:outline-none"
        disabled={!props.isCheckedIn || !isEdit}
        placeholder="Value"
        value={value}
        onChange={(e) => {
          setValue(e.target.value)
        }} />
        <div className='flex justify-between items-center mt-4 w-full'>
        <input
          style={{ cursor: (!props.isCheckedIn || !isEdit) ? "not-allowed" : "auto", height: "28px", width: "194px", borderRadius: "2px" }}
          className="bg-white border border-gray-300 text-gray-900 text-base block p-1.5 cursor-pointer focus:outline-none"
          disabled={!props.isCheckedIn || !isEdit}
          placeholder="Icon Url"
          value={iconUrl}
          onChange={(e) => {
            setIconUrl(e.target.value)
          }} />
          {isEdit ?
        <SaveIcon
          className="cursor-pointer"
          style={{width:15, height:15}}
          onClick={editOption}
        />
        :
        <EditIcon
          className="cursor-pointer"
          style={{ stroke: "#505F7B", width: 15, height: 15}}
          onClick={editOption}
        />
      }
      <DeleteIcon
        className="cursor-pointer"
        style={{ stroke: "#505F7B", width:15, height:15 }}
        onClick={() => props.isCheckedIn && deleteOption()}
      />
      </div>
    </div>
    :
    <div className="flex items-center justify-between px-1 py-3 flex-wrap">
    <input
      style={{cursor: (!props.isCheckedIn || !isEdit) ? "not-allowed" : "auto", width:"85px", height:"28px", borderRadius:"2px"}}
      className="bg-white border border-gray-300 text-gray-900 text-base block p-1.5 focus:outline-none"
      disabled={!props.isCheckedIn || !isEdit}
      placeholder="Label"
      value={label}
      onChange={(e) => setLabel(e.target.value)} />
    <input
      style={{cursor: (!props.isCheckedIn || !isEdit) ? "not-allowed" : "auto", width:"85px", height:"28px", borderRadius:"2px"}}
      className="bg-white border border-gray-300 text-gray-900 text-base block p-1.5 focus:outline-none"
      disabled={!props.isCheckedIn || !isEdit}
      placeholder="Value"
      value={value}
      onChange={(e) => setValue(e.target.value)} />
      {isEdit ?
      <SaveIcon
        className=" items-center cursor-pointer"
        style={{width:15, height:15}}
        onClick={editOption}
      />
      :
      <EditIcon
        className="items-center cursor-pointer"
        style={{ stroke: "#505F7B", width: 15, height: 15}}
        onClick={editOption}
      />
    }
    <DeleteIcon
      className=" items-center cursor-pointer"
      style={{ stroke: "#505F7B", width:15, height:15 }}
      onClick={() => props.isCheckedIn && deleteOption()}
    />
      {
        pluginType === "Tag" && 
        <input
        style={{cursor: (!props.isCheckedIn || !isEdit) ? "not-allowed" : "auto", height:"28px", marginTop:"14px", borderRadius:"2px"}}
        className="bg-white border border-gray-300 text-gray-900 text-base block w-full p-1.5 cursor-pointer focus:outline-none"
        disabled={!props.isCheckedIn || !isEdit}
        placeholder="Icon Url"
        value={iconUrl}
        onChange={(e) => setIconUrl(e.target.value)} />
      }
  </div>
  )
}
